"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme) {
  var item = {
    fontSize: theme.fontSize,
    lineHeight: theme.lineHeight,
    paddingRight: theme.listItemPaddingRight,
    paddingLeft: theme.listItemPaddingLeft,
    paddingTop: theme.listItemPaddingTop || theme.paddingTop,
    paddingBottom: theme.listItemPaddingBottom || theme.paddingBottom,
    color: theme.listItemColor,
    background: theme.listItemBackground,
    borderTop: theme.listItemBorderTop,
    borderBottom: theme.listItemBorderBottom,
    borderLeft: theme.listItemBorderLeft,
    borderRight: theme.listItemBorderRight,
    border: theme.listItemBorder,
    fontFamily: theme.fontFamily,
    minWidth: '100%',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    margin: 0,
    position: 'relative',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    outline: '0 none',
    display: 'block',
    maxWidth: '100%',
    '&:focus': {
      cursor: 'pointer',
      outline: '0 none',
      color: theme.listItemFocusColor,
      background: theme.listItemFocusBackground
    },
    '&:hover': {
      cursor: 'pointer',
      background: theme.listItemHoverBackground,
      color: theme.listItemHoverColor,
      outline: '0 none'
    }
  };
  return {
    item: item,
    itemSelected: _objectSpread({}, item, {
      color: theme.listItemSelectedColor,
      background: theme.listItemSelectedBackground,
      '&:focus': _objectSpread({}, item['&:focus'], {
        color: theme.listItemFocusSelectedColor,
        background: theme.listItemFocusSelectedBackground
      }),
      '&:hover': _objectSpread({}, item['&:hover'], {
        color: theme.listItemHoverSelectedColor,
        background: theme.listItemHoverSelectedBackground
      })
    })
  };
}